export default function Footer() {
  return (
    <footer style={{ backgroundColor: "#1C1C1C" }}>
      <div className="max-w-5xl mx-auto px-4 md:px-8 py-10 md:py-14">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo texto */}
          <div className="font-serif text-xl md:text-2xl text-gold">
            Mujer Abundante
          </div>

          {/* Copyright */}
          <p className="font-sans text-xs md:text-sm text-cream/40 text-center">
            © {new Date().getFullYear()} Anna Sauch. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
}